import { render, staticRenderFns } from "./automationRuleAddComponent.vue?vue&type=template&id=95cdc4be&"
import script from "./automationRuleAddComponent.vue?vue&type=script&lang=js&"
export * from "./automationRuleAddComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports